import { useNavigate } from 'react-router-dom';
import { ResponsiveImage } from '@/components/ResponsiveImage';
import { formatRelativeTime } from '../../lib/relative-time';
import type { NotablePull } from './queries';

export interface PullEntryProps {
  pull: NotablePull;
  layout: 'vertical' | 'horizontal';
}

export function PullEntry({ pull, layout }: PullEntryProps): JSX.Element {
  const navigate = useNavigate();
  const relTime = formatRelativeTime(pull.created_at);
  const initials = pull.puller_initials ?? '??';

  const handleClick = () => {
    if (pull.pack_id) {
      void navigate(`/pack/${pull.pack_id}`);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid="pull-entry"
      className={`group relative cursor-pointer overflow-hidden rounded-lg ${
        layout === 'vertical' ? 'w-full' : 'w-[120px] flex-shrink-0'
      }`}
    >
      <ResponsiveImage
        urls={{
          thumb: pull.card_image_url_thumb,
          default: pull.card_image_url,
          _2x: pull.card_image_url_2x,
        }}
        sizes="120px"
        alt={pull.card_name}
        className="w-full aspect-[490/684] object-cover"
      />

      {/* Timestamp overlay */}
      <span className="absolute bottom-1 right-1 bg-black/70 text-[10px] text-text-2 px-1.5 py-0.5 rounded-sm">
        {relTime}
      </span>

      {/* Hover overlay */}
      <span className="absolute inset-x-0 bottom-0 bg-black/80 px-1.5 py-1 text-[10px] text-text-2 opacity-0 group-hover:opacity-100 transition-opacity">
        {initials} pulled {pull.card_name} {relTime === 'now' ? 'just now' : `${relTime} ago`}
      </span>
    </button>
  );
}
